export enum ProductEnum {
    ICRAPROWEB = 7,
    EICRAPRO = 8,
}

export enum ProductEnumLabel {
    "icraproweb"= 7,
    "eicrapro" = 8,
}